import DeptLocCommModel from '../models/deptloccommmodel';
const DeptLocCommCollection = Backbone.Collection.extend({
  model: DeptLocCommModel
});
export default DeptLocCommCollection;
